module.exports = __webpack_public_path__ + "img/light-l.8e140b27.png";